/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
/* ------------------------------------------------------------------------------------------
   LA NOTA DEL CLIENTE, QUE NO SE PIERDA

   El tema guardaba la nota con una llamada de fondo al salir del recuadro. Si el cliente
   escribe y pulsa «pagar» seguido, la llamada no llega a tiempo y el pedido entra sin nota:
   medido el 21/09/2026 en el pedido #2051, que llego a Shopify con la nota vacia.

   Aqui se hacen dos cosas, y con una sola basta:
     1. la nota viaja tambien como ATRIBUTO del carrito dentro del propio formulario, asi que
        va en el mismo envio que el boton de pagar y Shopify la guarda en el pedido;
     2. antes de salir se manda con sendBeacon, que el navegador entrega aunque se cambie de
        pagina.
   Los avisos van por delegacion en el documento: el carrito se vuelve a dibujar solo y los
   escuchadores puestos sobre el recuadro se perderian.
------------------------------------------------------------------------------------------ */
(function () {
  var CLAVE = 'Nota del cliente';

  function recuadro(dentro) {
    return (dentro || document).querySelector('.Cart__Note, #cart-note');
  }

  function escondido(forma) {
    var i = forma.querySelector('input[data-dg-nota]');
    if (!i) {
      i = document.createElement('input');
      i.type = 'hidden';
      i.name = 'attributes[' + CLAVE + ']';
      i.setAttribute('data-dg-nota', '');
      forma.appendChild(i);
    }
    return i;
  }

  document.addEventListener('input', function (e) {
    var caja = e.target;
    if (!caja.matches || !caja.matches('.Cart__Note, #cart-note')) return;
    var forma = caja.closest('form');
    if (forma) escondido(forma).value = caja.value;
  });

  document.addEventListener('submit', function (e) {
    var forma = e.target;
    if (!forma || !forma.action || forma.action.indexOf('/cart') === -1) return;
    var caja = recuadro(forma) || recuadro(document);
    if (!caja) return;
    escondido(forma).value = caja.value;
    if (navigator.sendBeacon) {
      var cuerpo = new Blob([JSON.stringify({ note: caja.value })], { type: 'application/json' });
      navigator.sendBeacon((window.routes && window.routes.cartUrl ? window.routes.cartUrl : '/cart') + '/update.js', cuerpo);
    }
  }, true);
})();
